export default __webpack_public_path__ + "static/media/pharma-bg.701d3377.png";